import React, { useState } from 'react';
import { Navbar as BSNavbar, Container, Nav, NavDropdown } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Navbar = () => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const [showProfileModal, setShowProfileModal] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const getRoleName = (role) => {
    const roleNames = {
      'jr_inspector': 'Inspector',
      'sr_inspector': 'Reviewer',
      'admin': 'Administrator'
    };
    return roleNames[role] || role;
  };

  return (
    <>
      <BSNavbar bg="primary" variant="dark" expand="lg" className="shadow-sm">
        <Container fluid>
          {/* Company Name/Brand - Always goes to home */}
          <BSNavbar.Brand
            onClick={() => navigate('/')}
            style={{ cursor: 'pointer' }}
            className="fw-bold"
          >
            <i className="fas fa-industry me-2"></i>
            DYNAVATIVE INDO VERITAS
          </BSNavbar.Brand>

          <BSNavbar.Toggle aria-controls="basic-navbar-nav" />
          <BSNavbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto align-items-center">
              {/* Home Link */}
              <Nav.Link onClick={() => navigate('/')} className="text-white">
                <i className="fas fa-home me-1"></i>
                Home
              </Nav.Link>

              {/* Dashboard Link */}
              <Nav.Link
                onClick={() => navigate(`/dashboard/${user?.role}`)}
                className="text-white"
              >
                <i className="fas fa-tachometer-alt me-1"></i>
                Dashboard
              </Nav.Link>

              {/* User Dropdown */}
              <NavDropdown
                title={
                  <span className="text-white">
                    <i className="fas fa-user-circle me-1"></i>
                    {user?.full_name}
                  </span>
                }
                id="user-dropdown"
                align="end"
                className="text-white"
              >
                <NavDropdown.Item disabled className="text-muted small">
                  <strong>Role:</strong> {getRoleName(user?.role)}
                </NavDropdown.Item>
                <NavDropdown.Item disabled className="text-muted small">
                  <strong>Email:</strong> {user?.email}
                </NavDropdown.Item>
                <NavDropdown.Item disabled className="text-muted small">
                  <strong>Emp Code:</strong> {user?.emp_code}
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item onClick={() => navigate('/profile')}>
                  <i className="fas fa-user-edit me-2"></i>
                  Edit Profile
                </NavDropdown.Item>
                <NavDropdown.Item onClick={() => navigate('/change-password')}>
                  <i className="fas fa-key me-2"></i>
                  Change Password
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item onClick={handleLogout} className="text-danger">
                  <i className="fas fa-sign-out-alt me-2"></i>
                  Logout
                </NavDropdown.Item>
              </NavDropdown>
            </Nav>
          </BSNavbar.Collapse>
        </Container>
      </BSNavbar>

      {/* Quick Home Link - Top Right */}
      <div
        style={{
          position: 'fixed',
          top: '70px',
          right: '20px',
          zIndex: 1000
        }}
      >
        <button
          className="btn btn-sm btn-outline-primary rounded-circle"
          onClick={() => navigate('/')}
          title="Go to Home"
          style={{ width: '40px', height: '40px' }}
        >
          <i className="fas fa-home"></i>
        </button>
      </div>

      {/* Quick Home Link - Top Left (below navbar) */}
      <div
        style={{
          position: 'fixed',
          top: '70px',
          left: '20px',
          zIndex: 1000
        }}
      >
        <button
          className="btn btn-sm btn-outline-secondary rounded-circle"
          onClick={() => navigate('/')}
          title="Back to Home"
          style={{ width: '40px', height: '40px' }}
        >
          <i className="fas fa-arrow-left"></i>
        </button>
      </div>
    </>
  );
};

export default Navbar;
